(function ($) {
  // On Dom Ready
  $(function () {
    // toggle mobile menu
    $(".menu-toggle").on("click", function () {
      $(this).toggleClass("open");
      $(".inner-wrap").toggleClass("move-left");
      $(".exit-off-canvas").toggleClass("open");
    });

    // close menu when exit-off-canvas clicked
    $(".exit-off-canvas").on("click", function () {
      $(".menu-toggle").removeClass("open");
      $(".inner-wrap").removeClass("move-left");
      $(".exit-off-canvas").removeClass("open");
    });

    // home page hero swiper
    const hero_background_slider = new Swiper(".hero-background-slider", {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      lazy: true,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // If we need pagination
      pagination: false,

      // Navigation arrows
      navigation: {
        nextEl: ".hero-background-slider .swiper-button-next",
        prevEl: ".hero-background-slider .swiper-button-prev",
      },
    });

    // testimonials swiper
    const testimonials_slider = new Swiper(".testimonials-slider", {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      lazy: true,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // If we need pagination
      pagination: false,

      // Navigation arrows
      navigation: {
        nextEl: ".testimonials-slider .swiper-button-next",
        prevEl: ".testimonials-slider .swiper-button-prev",
      },
    });

    // got to project sector page after clicking button
    $(".project-sector-filters .rws-button_lined").on("click", function (e) {
      e.preventDefault();
      const url = $(".project-sector-link").val();
      window.location.href = url;
    });
  });
})(jQuery);
